export const FirebaseConfig = {
	"projectId": "hangad-trans",
	"appId": "1:442874896489:web:79ad967a2f9a268fd6c2f8",
	"databaseURL": "https://hangad-trans-default-rtdb.firebaseio.com",
	"storageBucket": "hangad-trans.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyAeQpIuD1ZZPg--B2EjeH484TZ3VLJfzEc",
	"authDomain": "hangad-trans.firebaseapp.com",
	"messagingSenderId": "442874896489",
	"measurementId": "G-0HXLXH8C7T"
};